import { render, staticRenderFns } from "./SubmissionInspectorModal.vue?vue&type=template&id=72210da2&scoped=true&"
import script from "./SubmissionInspectorModal.vue?vue&type=script&lang=js&"
export * from "./SubmissionInspectorModal.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionInspectorModal.vue?vue&type=style&index=0&id=72210da2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72210da2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72210da2')) {
      api.createRecord('72210da2', component.options)
    } else {
      api.reload('72210da2', component.options)
    }
    module.hot.accept("./SubmissionInspectorModal.vue?vue&type=template&id=72210da2&scoped=true&", function () {
      api.rerender('72210da2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/submission-request/SubmissionInspectorModal.vue"
export default component.exports